import moment from "moment";

export function subtractBusinessDays (holidays: string[], date: moment.Moment, days: number): moment.Moment {
  let daysRemaining = days;
  const newDate = date;

  while (daysRemaining > 0) {
    newDate.add(-1, "days");
    if (isBusinessDay(holidays, newDate)) {
      daysRemaining--;
    }
  }
  return newDate;
}

export function addBusinessDays (holidays: string[], date: moment.Moment, days: number): moment.Moment {
  let daysRemaining = days;
  const newDate = date;

  while (daysRemaining > 0) {
    newDate.add(1, "days");
    if (isBusinessDay(holidays, newDate)) {
      daysRemaining--;
    }
  }
  return newDate;
}

export function isBusinessDay (holidays: string[], date: moment.Moment): boolean {
  const weekends = [0, 6];
  return !weekends.includes(date.day()) && !holidays.includes(date.format("YYYY-MM-DD"));
}